import { ComponentProps } from 'react';

import { StringWithSuggestions } from '~/utils/types';

interface SocialIconProps extends ComponentProps<'svg'> {
  icon: StringWithSuggestions<'apple' | 'twitter'>;
}

export const SocialIcon = (props: SocialIconProps) => {
  const { icon, ...otherProps } = props;
  let content = <g></g>;
  switch (icon) {
    case 'apple':
      content = (
        <>
          <title>Apple</title>
          <path
            d="M43.5839 37.4071C42.858 39.0841 41.9988 40.6277 41.0033 42.0469C39.6463 43.9817 38.5352 45.3209 37.6789 46.0646C36.3516 47.2853 34.9294 47.9105 33.4065 47.946C32.3132 47.946 30.9947 47.6349 29.4599 47.0038C27.9201 46.3757 26.5051 46.0646 25.2112 46.0646C23.8542 46.0646 22.3988 46.3757 20.8421 47.0038C19.2831 47.6349 18.0271 47.9638 17.0668 47.9964C15.6064 48.0586 14.1508 47.4157 12.6978 46.0646C11.7704 45.2557 10.6105 43.8691 9.22087 41.9047C7.72995 39.807 6.50422 37.3745 5.54395 34.6012C4.51554 31.6058 4 28.7051 4 25.8969C4 22.6801 4.69509 19.9057 6.08734 17.5807C7.18153 15.7132 8.63718 14.2401 10.4591 13.1586C12.2809 12.0772 14.2495 11.5261 16.3694 11.4908C17.5293 11.4908 19.0505 11.8496 20.9408 12.5548C22.8258 13.2623 24.0361 13.6211 24.5667 13.6211C24.9635 13.6211 26.308 13.2016 28.5874 12.3652C30.7428 11.5895 32.562 11.2683 34.0524 11.3948C38.0908 11.7207 41.1247 13.3127 43.1425 16.1807C39.5307 18.3691 37.7441 21.4342 37.7797 25.3662C37.8123 28.429 38.9233 30.9776 41.107 33.0013C42.0966 33.9405 43.2017 34.6664 44.4313 35.182C44.1646 35.9553 43.8832 36.696 43.5839 37.4071V37.4071ZM34.322 0.960762C34.322 3.36131 33.445 5.6027 31.6969 7.6773C29.5873 10.1436 27.0357 11.5687 24.2687 11.3439C24.2334 11.0559 24.213 10.7528 24.213 10.4343C24.213 8.12973 25.2162 5.66343 26.9978 3.6469C27.8872 2.6259 29.0185 1.77694 30.3903 1.09972C31.7591 0.432598 33.0539 0.0636663 34.2716 0.000488281C34.3072 0.321404 34.322 0.64234 34.322 0.960731V0.960762Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case 'facebook':
      content = (
        <>
          <title>Facebook</title>
          <path
            d="M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 35.9789 8.77641 45.908 20.25 47.7084V30.9375H14.1562V24H20.25V18.7125C20.25 12.6975 23.8331 9.375 29.3152 9.375C31.9402 9.375 34.6875 9.84375 34.6875 9.84375V15.75H31.6613C28.68 15.75 27.75 17.6002 27.75 19.5V24H34.4062L33.3422 30.9375H27.75V47.7084C39.2236 45.908 48 35.9789 48 24Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case 'linkedin':
      content = (
        <>
          <title>Linkedin</title>
          <path
            d="M44.4469 0H3.54375C1.58437 0 0 1.54688 0 3.45938V44.5312C0 46.4437 1.58437 48 3.54375 48H44.4469C46.4063 48 48 46.4438 48 44.5406V3.45938C48 1.54688 46.4063 0 44.4469 0ZM14.2406 40.9031H7.11563V17.9906H14.2406V40.9031ZM10.6781 14.8688C8.39063 14.8688 6.54375 13.0219 6.54375 10.7437C6.54375 8.46562 8.39063 6.61875 10.6781 6.61875C12.9563 6.61875 14.8031 8.46562 14.8031 10.7437C14.8031 13.0125 12.9563 14.8688 10.6781 14.8688ZM40.9031 40.9031H33.7875V29.7656C33.7875 27.1125 33.7406 23.6906 30.0844 23.6906C26.3812 23.6906 25.8187 26.5875 25.8187 29.5781V40.9031H18.7125V17.9906H25.5375V21.1219H25.6312C26.5781 19.3219 28.9031 17.4188 32.3625 17.4188C39.5719 17.4188 40.9031 22.1625 40.9031 28.3313V40.9031V40.9031Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case 'medium':
      content = (
        <>
          <title>Medium</title>
          <path
            d="M48 23.6554C48 30.0141 46.9344 35.1719 45.6194 35.1719C44.3045 35.1719 43.2393 30.0154 43.2393 23.6554C43.2393 17.2954 44.3049 12.1389 45.6194 12.1389C46.9339 12.1389 48 17.2949 48 23.6554Z"
            fill="currentColor"
          />
          <path
            d="M41.9254 23.6553C41.9254 30.7539 38.8949 36.5108 35.1565 36.5108C31.4182 36.5108 28.3877 30.7539 28.3877 23.6553C28.3877 16.5567 31.4177 10.7998 35.1561 10.7998C38.8944 10.7998 41.9249 16.5548 41.9249 23.6553"
            fill="currentColor"
          />
          <path
            d="M27.0749 23.6554C27.0749 31.1968 21.0139 37.3103 13.5377 37.3103C6.06146 37.3103 0 31.1955 0 23.6554C0 16.1153 6.061 10 13.5377 10C21.0143 10 27.0749 16.114 27.0749 23.6554Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case 'spotify':
      content = (
        <>
          <title>Spotify</title>
          <path
            d="M24 0C10.7455 0 0 10.7444 0 24C0 37.2556 10.7455 48 24 48C37.2545 48 48 37.2556 48 24C48 10.7444 37.2545 0 24 0ZM35.7091 34.5975C35.3236 35.28 34.6146 35.664 33.8837 35.664C33.5418 35.664 33.1891 35.5785 32.8655 35.3985C29.8691 33.7185 26.6037 32.6895 23.1527 32.34C19.6946 31.9935 16.28 32.3444 13 33.3916C11.9055 33.7411 10.7273 33.1364 10.3782 32.04C10.0255 30.9418 10.6327 29.7676 11.7309 29.4164C15.5564 28.1942 19.5454 27.7785 23.5745 28.188C27.5963 28.5975 31.4073 29.7975 34.9055 31.7582C35.9127 32.3189 36.2727 33.5909 35.7091 34.5975ZM38.5818 27.3076C38.2109 28.0215 37.4836 28.4309 36.7309 28.4309C36.4036 28.4309 36.0764 28.356 35.7673 28.1942C32.0836 26.2756 28.1054 25.0876 23.9345 24.6644C19.7309 24.2342 15.5673 24.6091 11.5527 25.7669C10.4436 26.0818 9.28729 25.4476 8.97093 24.3389C8.65093 23.232 9.2909 22.0756 10.3964 21.756C14.9273 20.4495 19.6254 20.0309 24.3564 20.5109C29.0545 20.9895 33.5418 22.3276 37.6982 24.4935C38.7164 25.0262 39.1164 26.2858 38.5818 27.3076ZM39.6218 21.2429C39.3091 21.2429 38.9927 21.1724 38.6909 21.024C34.32 18.8444 29.6182 17.4869 24.7127 16.9891C19.8 16.4865 14.9127 16.8749 10.1818 18.1382C9.06909 18.4335 7.92727 17.7735 7.62908 16.6589C7.3309 15.5458 7.99275 14.4015 9.10911 14.1044C14.3273 12.7109 19.7236 12.2865 25.1382 12.8371C30.5455 13.3844 35.7309 14.8829 40.5527 17.2876C41.5855 17.8018 42.0036 19.056 41.4909 20.0865C41.1273 20.82 40.3891 21.2429 39.6218 21.2429Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case 'twitter':
      content = (
        <>
          <title>Twitter</title>
          <path
            d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case 'x':
      content = (
        <>
          <title>X</title>
          <path
            d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case 'youtube':
      content = (
        <>
          <title>YouTube</title>
          <path
            d="M47.5219 14.4001C47.5219 14.4001 47.0531 11.0907 45.6094 9.6376C43.7812 7.7251 41.7375 7.71572 40.8 7.60322C34.0875 7.11572 24.0094 7.11572 24.0094 7.11572H23.9906C23.9906 7.11572 13.9125 7.11572 7.2 7.60322C6.2625 7.71572 4.21875 7.7251 2.39062 9.6376C0.946875 11.0907 0.4875 14.4001 0.4875 14.4001C0.4875 14.4001 0 18.2907 0 22.172V25.8095C0 29.6907 0.478125 33.5813 0.478125 33.5813C0.478125 33.5813 0.946875 36.8907 2.38125 38.3438C4.20937 40.2563 6.60938 40.1907 7.67813 40.397C11.5219 40.7626 24 40.8751 24 40.8751C24 40.8751 34.0875 40.8563 40.8 40.3782C41.7375 40.2657 43.7812 40.2563 45.6094 38.3438C47.0531 36.8907 47.5219 33.5813 47.5219 33.5813C47.5219 33.5813 48 29.7001 48 25.8095V22.172C48 18.2907 47.5219 14.4001 47.5219 14.4001ZM19.0406 30.2251V16.7345L32.0062 23.5032L19.0406 30.2251Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case 'instagram':
      content = (
        <>
          <title>Instagram</title>
          <path
            d="M24 4.32187C30.4125 4.32187 31.1719 4.35 33.6938 4.4625C36.0375 4.56562 37.3031 4.95938 38.1469 5.2875C39.2625 5.71875 40.0688 6.24375 40.9031 7.07812C41.7469 7.92188 42.2625 8.71875 42.6938 9.83438C43.0219 10.6781 43.4156 11.9531 43.5188 14.2875C43.6313 16.8187 43.6594 17.5781 43.6594 23.9813C43.6594 30.3938 43.6313 31.1531 43.5188 33.675C43.4156 36.0188 43.0219 37.2844 42.6938 38.1281C42.2625 39.2438 41.7375 40.05 40.9031 40.8844C40.0594 41.7281 39.2625 42.2438 38.1469 42.675C37.3031 43.0031 36.0281 43.3969 33.6938 43.5C31.1625 43.6125 30.4031 43.6406 24 43.6406C17.5875 43.6406 16.8281 43.6125 14.3063 43.5C11.9625 43.3969 10.6969 43.0031 9.85313 42.675C8.7375 42.2438 7.93125 41.7188 7.09688 40.8844C6.25313 40.0406 5.7375 39.2438 5.30625 38.1281C4.97813 37.2844 4.58438 36.0094 4.48125 33.675C4.36875 31.1438 4.34063 30.3844 4.34063 23.9813C4.34063 17.5688 4.36875 16.8094 4.48125 14.2875C4.58438 11.9437 4.97813 10.6781 5.30625 9.83438C5.7375 8.71875 6.2625 7.9125 7.09688 7.07812C7.94063 6.23438 8.7375 5.71875 9.85313 5.2875C10.6969 4.95938 11.9719 4.56562 14.3063 4.4625C16.8281 4.35 17.5875 4.32187 24 4.32187ZM24 0C17.4844 0 16.6688 0.028125 14.1094 0.140625C11.5594 0.253125 9.80625 0.665625 8.2875 1.25625C6.70312 1.875 5.3625 2.69062 4.03125 4.03125C2.69063 5.3625 1.875 6.70313 1.25625 8.27813C0.665625 9.80625 0.253125 11.55 0.140625 14.1C0.028125 16.6687 0 17.4844 0 24C0 30.5156 0.028125 31.3312 0.140625 33.8906C0.253125 36.4406 0.665625 38.1938 1.25625 39.7125C1.875 41.2969 2.69063 42.6375 4.03125 43.9688C5.3625 45.3 6.70313 46.125 8.27813 46.7344C9.80625 47.325 11.55 47.7375 14.1 47.85C16.6594 47.9625 17.475 47.9906 23.9906 47.9906C30.5063 47.9906 31.3219 47.9625 33.8813 47.85C36.4313 47.7375 38.1844 47.325 39.7031 46.7344C41.2781 46.125 42.6188 45.3 43.95 43.9688C45.2812 42.6375 46.1063 41.2969 46.7156 39.7219C47.3063 38.1938 47.7188 36.45 47.8313 33.9C47.9438 31.3406 47.9719 30.525 47.9719 24.0094C47.9719 17.4938 47.9438 16.6781 47.8313 14.1188C47.7188 11.5688 47.3063 9.81563 46.7156 8.29688C46.125 6.70312 45.3094 5.3625 43.9688 4.03125C42.6375 2.7 41.2969 1.875 39.7219 1.26562C38.1938 0.675 36.45 0.2625 33.9 0.15C31.3313 0.028125 30.5156 0 24 0Z"
            fill="currentColor"
          />
          <path
            d="M24 11.6719C17.1938 11.6719 11.6719 17.1938 11.6719 24C11.6719 30.8062 17.1938 36.3281 24 36.3281C30.8062 36.3281 36.3281 30.8062 36.3281 24C36.3281 17.1938 30.8062 11.6719 24 11.6719ZM24 31.9969C19.5844 31.9969 16.0031 28.4156 16.0031 24C16.0031 19.5844 19.5844 16.0031 24 16.0031C28.4156 16.0031 31.9969 19.5844 31.9969 24C31.9969 28.4156 28.4156 31.9969 24 31.9969Z"
            fill="currentColor"
          />
          <path
            d="M39.6937 11.1843C39.6937 12.778 38.4 14.0624 36.8156 14.0624C35.2219 14.0624 33.9375 12.7687 33.9375 11.1843C33.9375 9.59053 35.2313 8.30615 36.8156 8.30615C38.4 8.30615 39.6937 9.5999 39.6937 11.1843Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case 'google':
      content = (
        <>
          <title>Google</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.6866 13.0956C31.2086 10.7322 27.9016 9.4447 24.48 9.49761C18.2187 9.49761 12.9011 13.7217 11.0051 19.4097C9.99973 22.3904 9.99973 25.6182 11.0051 28.5989H11.0139C12.9187 34.2781 18.2275 38.5022 24.4888 38.5022C27.7208 38.5022 30.4956 37.6755 32.6461 36.2154V36.2094C35.177 34.5339 36.9055 31.8971 37.4434 28.9164H24.48V19.6744H47.1175C47.3997 21.2794 47.532 22.9197 47.532 24.5512C47.532 31.8508 44.9232 38.0224 40.3841 42.2024L40.3888 42.2061C36.4116 45.8746 30.9529 47.9999 24.48 47.9999C15.4056 47.9999 7.10718 42.8851 3.03296 34.7808C-0.371021 27.9992 -0.371012 20.0095 3.03298 13.228C7.10721 5.11479 15.4055 -9.16524e-05 24.48 -9.16524e-05C30.4414 -0.070641 36.2 2.1693 40.5387 6.24352L33.6866 13.0956Z"
            fill="currentColor"
          />
        </>
      );
      break;
    default:
      // If no social icon exists we just use the first letter of the icon name
      // TODO: Fix this functionality
      content = (
        <text
          fontSize="24rem"
          fill="currentColor"
          strokeWidth="0"
          textAnchor="middle"
          xmlSpace="preserve"
          stroke="#000"
        >
          {icon.charAt(0) ?? ''}
        </text>
      );
      break;
  }
  return (
    <svg
      width="1em"
      height="1em"
      viewBox={`0 0 ${icon === 'x' || icon === 'twitter' ? '1200 1227' : '48 48'}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      {content}
    </svg>
  );
};
